exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error{min-height:100vh;position:relative;background-color:#1e0564;color:#fff}", ""]);

